// 导入组件，组件必须声明 name
import FeedbackList from './src/pages/my-feedback.vue';
import SendFeedback from './src/pages/send.vue';
import env from './src/utils/env';
import vueI18n from '@/i18n/locale';

// 导出组件
let instance, secInstance;
let IVue = null;

class FeedbackPlugin {
  install(Vue, options, isRegisterGlobal) {
    const { config, ...other } = options;
    env.set('options', other);
    env.set('config', config);
    IVue = Vue;
    if (isRegisterGlobal) {
      Vue.component(FeedbackList.name, FeedbackList);
      Vue.component(SendFeedback.name, SendFeedback);
    }
  }

  viewOpen() {
    let FeedbackConstructor = IVue.extend(FeedbackList);
    if (!instance) {
      instance = new FeedbackConstructor({
        i18n: vueI18n,
      });
      const { locale } = env.get('options');
      vueI18n.locale = locale;
      instance.$mount();
      document.body.appendChild(instance.$el);
    }
    instance.viewOpen = true;
    return instance;
  }

  sendOpen() {
    let FeedbackConstructor = IVue.extend(SendFeedback);
    if (!secInstance) {
      secInstance = new FeedbackConstructor({
        i18n: vueI18n,
      });
      const { locale } = env.get('options');
      vueI18n.locale = locale;
      secInstance.$mount();
      document.body.appendChild(secInstance.$el);
    }
    secInstance.sendOpen = true;
    return secInstance;
  }

  close() {
    if (instance) {
      instance.view = false;
    }
  }
}

export default new FeedbackPlugin();
